import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Input, Icon, Button, Col, Row } from 'antd';
import {
  SortableContainer,
  SortableElement,
} from 'react-sortable-hoc';
import arrayMove from 'array-move';
import { DragIcon } from '../../common/icons/DragIcon';
import CheckboxGroup from 'antd/lib/checkbox/Group';
import { MOBILE_BREAK_POINT } from 'src/globals';

const Search = Input.Search;

const styles = theme => ({
  modal : {
    '& .ant-modal-body': {
      padding: '24px 24px 16px 24px',
    },
    '& .ant-modal-footer': {
      borderTop: 0,
    },
  },
  listItemStyle: {
    marginBottom:'10px',
    backgroundColor: '#D5E9FF',
    borderRadius: '4px',
    paddingLeft:'8px',
    paddingRight: '8px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
  mainDiv: {
    height:'350px',
    display: 'flex',
    overflow:'hidden',
    justifyContent: 'space-between',

    '& .ant-checkbox-group-item': {
      marginRight: '0px',

      '& .ant-checkbox': {
        margin: '3px 0px 0px 0px',
      },

      '& .ant-checkbox + span': {
        width: '100%',
      },
    },
  },
  leftDiv: {
    width: '48%',
    display: 'flex',
    flexDirection: 'column',
    '& .ant-checkbox-group-item': {
      marginBottom: '12px',
      display: 'flex',
    },
    '& .ant-checkbox-group': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'unset',
      height: 'auto',
    },
  },
  searchStyle: {
  },
  rightDiv: {
    overflow:'auto',
    border: '1px solid #E8E8E8',
    padding: '12px',
    width: '48%',
    '& ul': {
      padding: 0,
      'list-style-type': 'none',
    },
  },
  checkboxDiv: {
    overflow:'auto',
    border: '1px solid #E8E8E8',
    height: '100%',
    padding: '16px',
  },
  okButtonStyle: {
    backgroundColor: '#0780FE',
    border: '1px solid #0780FE',
    marginRight: '8px',
  },
  price: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
    modal: {
      minWidth: '600px',
    },
  },
});

interface Props {
  isVisible: boolean;
  fullColumnList?: {column_id:string, pretty_name:string, column_price}[];
  columnsToShow?: {column_id:string, pretty_name:string, column_price}[];
  onModalClose: any;
  setColumns: any;
}

class CustomColumnsModal extends React.PureComponent<any, any> {

  state: any = {
    isUploading: false,
    items: [], // Contains value or column_id of selected or existing columns
    allOptions : [],
  };

  componentDidMount() {
    // Created mapping to render the checkboxes
    // pretty_name => label
    // column_id => value
    const allOptions = this.getAllOptions();
    const existingColumns = this.props.columnsToShow.map((ele) => {
      return (ele.column_id);
    });
    this.setState({
      allOptions,
      items:existingColumns,
    });
  }

  getAllOptions = () => {
    return this.props.fullColumnList.map((ele) => {
      return ({ label: <Row>
        <Col span={12}>{ele.pretty_name}</Col>
      <Col span={12} className={this.props.classes.price}>{ele.column_price}</Col>
      </Row>, value: ele.column_id  });
    });
  }

  ListItem = (record: any) => {
    const { classes, columnsToShow } = this.props;
    return (
      <div className={classes.listItemStyle}>
        <div>
          <DragIcon />
          <span style={{ marginLeft: '8px' }}>
            {columnsToShow.filter(
              x => x.column_id === record.record.value)[0].pretty_name}
          </span>
        </div>
        <div>
          <Icon type="close" onClick={() => this.handleCrossClick(record.record.value)} />
        </div>
      </div>
    );
  }

  handleCrossClick = (value) => {
    this.setState({
      items: this.state.items.filter(x => x !== value),
    });
  }

  onCheckboxChange = (checkedValues) => {
    const uncheckedValues = this.state.allOptions
    .filter(option => !checkedValues.includes(option.value))
    .map(option => option.value);
    const uncheckedSet = new Set(uncheckedValues);
    const union = new Set([...this.state.items, ...checkedValues]);
    const intersection = new Set(Array.from(union).filter(x => !uncheckedSet.has(x)));
    this.setState({
      items: Array.from(intersection),
    });
  }

  SortableItem = SortableElement((props: any) => <this.ListItem record={props} />);

  SortableList = SortableContainer((props: any) => {
    return (
      <ul>
        {props.items.map((value, index) => (
          <this.SortableItem key={`item-${index}`} index={index} value={value} />
        ))}
      </ul>
    );
  });

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ items }) => ({
      items: arrayMove(items, oldIndex, newIndex),
    }));
  }

  handleModalOk = () => {
    const columns = this.state.items.map((element) => {
      return this.props.fullColumnList.filter(x => (x.column_id === element))[0];
    });
    this.props.onModalok(columns.map((item) => {
      return item.id;
    }));
    this.setState({ allOptions: this.getAllOptions() });
  }

  handleModalClose = () => {
    this.props.onModalClose();
  }

  handleSearchChange = (e) => {
    this.setState({
      allOptions: this.props.fullColumnList
        .filter(x =>
          x.pretty_name
            .toLowerCase()
            .includes(e.target.value.toLowerCase()),
        )
        .map(ele => ({ label: <Row>
          <Col span={12}>{ele.pretty_name}</Col>
        <Col span={12} className={this.props.classes.price}>{ele.column_price}</Col>
        </Row>, value: ele.column_id }),
        ),
    });
  }

  render() {
    const { isVisible, classes, isBidComparisonCustomize } = this.props;
    const { isUploading } = this.state;
    return (
      <Modal title={isBidComparisonCustomize ? 'Customize Bid Comparison' :
      'Customize Columns'}
        className={classes.modal}
        destroyOnClose maskClosable={false}
        width={isBidComparisonCustomize ? 600 : 800}
        visible={isVisible}
        confirmLoading={isUploading}
        onCancel={this.handleModalClose}
        footer={[
          <>{isBidComparisonCustomize ? undefined :
          <Button key="back" onClick={this.handleModalClose} > Cancel
          </Button>}
          <Button key="submit" type="primary" className={classes.okButtonStyle}
          style={ isBidComparisonCustomize ? { padding: '0px 30px' } : undefined}
          size="large" onClick={this.handleModalOk}>
            {isBidComparisonCustomize ? 'Okay' :
            'Update'}
          </Button></>,
        ]}
      >
      <div className={classes.mainDiv}>
        <div className={classes.leftDiv} >
          <div style={{
            padding: '12px', border: '1px solid #E8E8E8' }}>
            <Search
              onChange={this.handleSearchChange}
              className={classes.searchStyle}
              placeholder={isBidComparisonCustomize ? 'Search Rank' :
              'Search'}
            />
          </div>
          <div className={classes.checkboxDiv}>
              <CheckboxGroup className={classes.mainDiv}
              options={this.state.allOptions} value={this.state.items}
              onChange={this.onCheckboxChange} />
          </div>
        </div>
        <div className={classes.rightDiv} >
          <div style={{
            fontWeight:600, fontSize:'14px',
            color:'#424242',
            marginBottom:'12px' }} >
            {isBidComparisonCustomize ? 'Existing Bids for comparison' :
            'Existing Columns'}
          </div>
          <div><this.SortableList distance={1} items={this.state.items} onSortEnd={this.onSortEnd}
            helperClass="sortableHelper" />
            </div>
        </div>
      </div>
      </Modal>
    );
  }
}

const StyledCustomModal = injectSheet(styles)(CustomColumnsModal);
export default StyledCustomModal;
